// styles/theme.js
export const theme = {
  colors: {
    background: '#E0D2BF',
    backgroundLight: '#F5EDE3',
    primary: '#9A6767',
    primaryDark: '#7a4f4f',
    primaryLight: '#b88a8a',
    white: '#FFFFFF',
    black: '#333333',
    gray: '#F5F5F5',
    darkGray: '#666666',
    error: '#FF6B6B',
    success: '#4CAF50',
    warning: '#FFC107',
    beige: '#D4C4B0',
    cream: '#F9F5F0'
  },
  fonts: {
    main: "'Roboto', sans-serif",
    secondary: "'Open Sans', sans-serif"
  },
  fontSizes: {
    small: '0.875rem',
    medium: '1rem',
    large: '1.25rem',
    xlarge: '1.5rem',
    xxlarge: '2rem'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%'
  },
  shadows: {
    small: '0 2px 4px rgba(0,0,0,0.1)',
    medium: '0 4px 8px rgba(0,0,0,0.15)',
    large: '0 8px 16px rgba(0,0,0,0.2)'
  }
};